import { REQUEST_CODE_TOP } from 'constants/index';

const recordLink = (data) => {
  const pageName  = window.utag_last_name;
  window.utag && window.utag.link && window.utag.link({
    ...data,
    eventCategory: pageName
  });
}

const modifyEmailClickTextBoxLink = () => {
  recordLink({
    action: 'type',
    format: 'textBox',
    component: 'modifyEmail',
    element: 'newEmail',
    eventAction: 'clickTextBox',
    eventLabel: 'newEmailTextBox'
  })
}

const repeatEmailClickTextBoxLink = () => {
  recordLink({
    action: 'type',
    format: 'textBox',
    component: 'modifyEmail',
    element: 'repeatNewEmail',
    eventAction: 'clickTextBox',
    eventLabel: 'repeatNewEmailTextBox'
  })
}

const emailSentModalLink = () => {
  recordLink({
    action: 'open',
    format: 'modal',
    component: 'modal/emailCodeSent',
    element: 'full',
    eventAction: 'emailCodeSent',
    eventLabel: 'open'
  })
}

const emailSentModalCloseLink = () => {
  recordLink({
    action: 'close',
    format: 'cross',
    component: 'modal/emailCodeSent',
    element: 'cross',
    eventAction: 'emailCodeSent',
    eventLabel: 'close'
  })
}

const starOtpEmailAuthLink = () => {
  recordLink({
    action:'start',
    format:'otpAuthentication',
    component:'OTP/email',
    element:'backend',
    eventAction: 'otpAuthenticationEmail',
    eventLabel: 'start',
  })
}

const otpClickTextBoxLink = () => {
  recordLink({
    action: 'type',
    format: 'textBox',
    component: 'OTP/email',
    element: 'verificationCode',
    eventAction: 'clickTextBox',
    eventLabel: 'verificationCodeTextBox'
  })
}

const requestNewOtpLink = () => {
  recordLink({
    action: 'request',
    format: 'link',
    component: 'OTP/email',
    element: 'requestNewCode',
    eventAction: 'clickLink',
    eventLabel: 'requestNewCodeLink'
  })
}

const otpAuthenticationLink = () => {
  recordLink({
    action:'success',
    format:'otpAuthentication',
    component:'OTP/email',
    element:'backend',
    eventAction: 'otpAuthenticationEmail',
    eventLabel: 'success'
  })
}

const wizardEventNavigation = () => ({
    next: {
        data: true,
        action: 'continue',
        format: 'button',
        component: 'lowerNavigation',
        element: 'next',
        eventCategory:  window.utag_last_name || '',
        eventAction: 'lowerNavigation',
        eventLabel: 'next'
    },
    previous: {
        data: true,
        action: 'return',
        format: 'button',
        component: 'lowerNavigation',
        element: 'previous',
        eventCategory:  window.utag_last_name || '',
        eventAction: 'lowerNavigation',
        eventLabel: 'previous'
    },
    cancel: {
        data: true,
        action: 'cancel',
        format: 'link',
        component: 'lowerNavigation',
        element: 'cancel',
        eventCategory:  window.utag_last_name || '',
        eventAction: 'lowerNavigation',
        eventLabel: 'cancel'
    },
    finish: {
        data: true,
        action: 'click',
        format: 'button',
        component: 'lowerNavigation',
        element: 'modify',
        eventCategory:  window.utag_last_name || '',
        eventAction: 'lowerNavigation',
        eventLabel: 'modify'
    }
});

const editEmailSignatureStartLink = () => {
  recordLink({
    action:'start',
    format:'signatureKey',
    component:'confirmation',
    element:'backend',
    eventAction: 'signatureKey',
    eventLabel: 'start'
  })
}

const editEmailSignatureKeypressLink = () => {
  recordLink({
    action: 'type',
    format: 'textBox',
    component: 'signatureKey',
    element: 'verificationCode',
    eventAction: 'clickTextBox',
    eventLabel: 'verificationCodeTextBox'
  })
}

const tealiumEmailWizard = [
  {
      pageName: '/modifyEmail/step01/modifyYourEmail',
      sectionFamily: 'banking',
      sectionCategory: 'services',
      sectionName: 'customer',
      processType: 'modifyEmail',
      processStep: 'step01',
      processsDetail: 'modifyYourEmail',
      interactionType: 'funnel',
      serviceType: 'userInformation'
  },
{
      pageName: '/modifyEmail/step02/verifyEmail',
      sectionFamily: 'banking',
      sectionCategory: 'services',
      sectionName: 'customer',
      processType: 'modifyEmail',
      processStep: 'step02',
      processsDetail: 'verifyEmail',
      interactionType: 'funnel',
      serviceType: 'userInformation',
  },
  {
      pageName: '/modifyEmail/step03/confirmation',
      sectionFamily: 'banking',
      sectionCategory: 'services',
      sectionName: 'customer',
      processType: 'modifyEmail',
      processStep: 'step02',
      processsDetail: 'confirmation',
      interactionType: 'funnel',
      serviceType: 'userInformation',
  }
];

const errorRequiredFieldOTPLink = (errorMsg) => {
  recordLink({
    action: 'click',
    format: 'textBox',
    component: 'OTP/SMS',
    element: 'errorRequiredFieldOTP',
    errorCategory: 'requiredFieldOTP',
    errorDescription: errorMsg,
    eventAction: 'errorRequiredFieldOTP',
    eventLabel: 'error - textBox'
  })
}

const errorIncorrectOTPLink = (errorMsg) => {
  recordLink({
    action: 'click',
    format: 'textBox',
    component: 'OTP/SMS',
    element: 'errorIncorrectOTP',
    errorCategory: 'incorrectOTP',
    errorDescription: errorMsg,
    eventAction: 'errorIncorrectOTP',
    eventLabel: 'error - textBox'
  })
}

const maxRequestsNumberErrorLink = () => {
  recordLink({
    action: 'open',
    format: 'message',
    component: 'message/warning/maxRequestsNumber',
    element: 'full',
    eventAction: 'warningMessageMaxRequestsNumber',
    eventLabel: 'view'
  })
}

const expiredCodeErrorLink = () => {
  recordLink({
    action: 'open',
    format: 'message',
    component: 'message/error/expiredCode',
    element: 'full',
    eventAction: 'errorMessageExpiredCode',
    eventLabel: 'view'
  })
}

const maxAttemptsOTPErrorLink = () => {
  recordLink({
    action: 'open',
    format: 'message',
    component: 'message/error/OTPMaxAttempts',
    element: 'full',
    eventAction: 'errorMessageOTPMaxAttempts',
    eventLabel: 'view'
  })
}

const sameEmailErrorLink = (errorMsg) => {
  recordLink({
    action: 'click',
    format: 'textBox',
    component: 'modifyEmail',
    element: 'errorEmail',
    errorCategory: 'errorSameEmail',
    errorDescription: errorMsg,
    eventAction: 'errorSameEmail',
    eventLabel: 'error - textBox'
  })
}

const requestGenericErrorLink = (errorCode) => {
  if(errorCode !== REQUEST_CODE_TOP) {
    recordLink({
      action: 'open',
      format: 'snackbar',
      component: 'snackbar/error/newCodeNotSent',
      element: 'full',
      eventAction: 'errorSnackbarNewCodeNotSent',
      eventLabel: 'view'
    });
  }
}

export {
  modifyEmailClickTextBoxLink,
  repeatEmailClickTextBoxLink,
  emailSentModalLink,
  emailSentModalCloseLink,
  starOtpEmailAuthLink,
  otpClickTextBoxLink,
  requestNewOtpLink,
  otpAuthenticationLink,
  wizardEventNavigation,
  editEmailSignatureStartLink,
  editEmailSignatureKeypressLink,
  tealiumEmailWizard,
  errorRequiredFieldOTPLink,
  errorIncorrectOTPLink,
  maxRequestsNumberErrorLink,
  expiredCodeErrorLink,
  maxAttemptsOTPErrorLink,
  sameEmailErrorLink,
  requestGenericErrorLink,
}